export function validateFloatNumber(value: string) {
  let newValue = value.split(',');
  if (newValue[1] === '00') {
    return newValue[0];
  } else {
    return `${newValue[0]},${newValue[1]}`;
  }
}
